var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, IconButton, LinearProgress, Skeleton, Stack, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { BackArrowIcon } from '../../../components/icons';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from '../../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { utility } from '../../../utils';
import constants from '../../../config/constants';
import { NavigationConfig } from '../../../utils/navigation_config';
import { PORTAL_TAB_ORDER } from './portalDetail.constants';
import { usePortalConfig } from './usePortalConfig';
import { usePortalPermissions } from './usePortalPermissions';
import { PORTAL_EDIT_BUTTON_ID, PortalCreateHeader, PortalEditButton, PortalSummaryStrip, PortalTabs, StickyActionBar, portalPanelId, portalTabId, } from './components/PortalChrome';
import ConfigurationsTab from './components/ConfigurationsTab';
import BrandingTab from './components/BrandingTab';
import { portalColors } from './components/PortalUi';
var EDIT_LABELS = {
    configurations: 'Edit Configurations',
    branding: 'Edit Branding',
};
var FOCUSABLE = 'input:not([disabled]):not([type="hidden"]), select:not([disabled]), button:not([disabled])';
var LoadingSkeleton = function () { return (React.createElement(Box, { "aria-busy": "true", "aria-label": "Loading portal" },
    React.createElement(Skeleton, { variant: "rounded", height: 84, sx: { mb: 2, borderRadius: '12px' } }),
    React.createElement(Skeleton, { variant: "rounded", height: 64, width: 460, sx: { mb: 2, borderRadius: '14px' } }),
    [220, 150, 150].map(function (height, index) { return (React.createElement(Skeleton, { key: index, variant: "rounded", height: height, sx: { mb: 2, borderRadius: '12px' } })); }))); };
var PortalDetailPageContent = function (_a) {
    var _b;
    var _c = _a.mode, mode = _c === void 0 ? 'edit' : _c, _d = _a.initialEdit, initialEdit = _d === void 0 ? false : _d;
    var navigate = useNavigate();
    var id = useParams().id;
    var isCreate = mode === 'create';
    var vendorId = isCreate ? 0 : Number(id);
    var access = usePortalPermissions();
    var visibleTabs = access.visibleTabs;
    var canCreate = access.tabs.configurations.visible && (access.portal.add || access.tabs.configurations.add);
    var canContinueToBranding = access.tabs.branding.update;
    var location = useLocation();
    var landing = location.state;
    var config = usePortalConfig(vendorId, mode);
    var _e = useState('configurations'), selectedTab = _e[0], setSelectedTab = _e[1];
    var activeTab = isCreate
        ? (canCreate ? 'configurations' : null)
        : visibleTabs.includes(selectedTab) ? selectedTab : (_b = visibleTabs[0]) !== null && _b !== void 0 ? _b : null;
    var canEditActiveTab = activeTab ? access.tabs[activeTab].update : false;
    var _f = useState(null), editingTab = _f[0], setEditingTab = _f[1];
    var _g = useState(false), unsavedOpen = _g[0], setUnsavedOpen = _g[1];
    var _h = useState(false), confirmCreateOpen = _h[0], setConfirmCreateOpen = _h[1];
    var _j = useState(false), quitCreateOpen = _j[0], setQuitCreateOpen = _j[1];
    var _k = useState(null), createdVendorId = _k[0], setCreatedVendorId = _k[1];
    var pendingAction = useRef(null);
    var panelRef = useRef(null);
    var previousEditingTab = useRef(null);
    var hasUnsavedChanges = isCreate ? config.isDirty : Boolean(editingTab && config.isTabDirty(editingTab));
    var exitEdit = function () {
        config.resetChanges(editingTab !== null && editingTab !== void 0 ? editingTab : undefined);
        setEditingTab(null);
    };
    var guardUnsaved = function (action) {
        if (editingTab && hasUnsavedChanges) {
            pendingAction.current = action;
            setUnsavedOpen(true);
        }
        else {
            if (editingTab)
                exitEdit();
            action();
        }
    };
    var handleConfirmedCreate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newVendorId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setConfirmCreateOpen(false);
                    return [4, config.createPortal()];
                case 1:
                    newVendorId = _a.sent();
                    if (newVendorId)
                        setCreatedVendorId(newVendorId);
                    return [2];
            }
        });
    }); };
    var goToPortalList = function () {
        setCreatedVendorId(null);
        navigate(NavigationConfig.DealerManagement);
    };
    var continueToBranding = function () {
        var target = createdVendorId;
        setCreatedVendorId(null);
        navigate("".concat(NavigationConfig.DealerManagement, "/view/").concat(target), { state: { openTab: 'branding', startEditing: true } });
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var invalidKeys, saveTab, _a, next;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    invalidKeys = config.validate(isCreate ? undefined : activeTab !== null && activeTab !== void 0 ? activeTab : undefined);
                    if (invalidKeys.length) {
                        utility.alert('Please fix the highlighted fields before saving.', constants.TOAST_TYPES.ERROR);
                        window.setTimeout(function () {
                            var _a, _b;
                            var target = (_a = panelRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-invalid="true"]');
                            target === null || target === void 0 ? void 0 : target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            (_b = target === null || target === void 0 ? void 0 : target.querySelector(FOCUSABLE)) === null || _b === void 0 ? void 0 : _b.focus({ preventScroll: true });
                        }, 50);
                        return [2];
                    }
                    if (isCreate) {
                        setConfirmCreateOpen(true);
                        return [2];
                    }
                    saveTab = editingTab !== null && editingTab !== void 0 ? editingTab : activeTab;
                    _a = saveTab;
                    if (!_a) return [3, 2];
                    return [4, config.save(saveTab)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    if (_a) {
                        setEditingTab(null);
                        next = pendingAction.current;
                        pendingAction.current = null;
                        next === null || next === void 0 ? void 0 : next();
                    }
                    return [2];
            }
        });
    }); };
    var startedInEdit = useRef(false);
    useEffect(function () {
        if (isCreate || startedInEdit.current || !config.isLoaded)
            return;
        if (!(initialEdit || (landing === null || landing === void 0 ? void 0 : landing.startEditing)))
            return;
        var requested = (landing === null || landing === void 0 ? void 0 : landing.openTab) && access.editableTabs.includes(landing.openTab) ? landing.openTab : undefined;
        var target = requested !== null && requested !== void 0 ? requested : access.editableTabs[0];
        if (!target)
            return;
        startedInEdit.current = true;
        setSelectedTab(target);
        setEditingTab(target);
        if (landing)
            navigate(location.pathname, { replace: true, state: null });
    }, [initialEdit, isCreate, landing, access.editableTabs, config.isLoaded, navigate, location.pathname]);
    useEffect(function () {
        if (!(isCreate || editingTab) || !hasUnsavedChanges || createdVendorId !== null)
            return undefined;
        var warn = function (event) {
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', warn);
        return function () { return window.removeEventListener('beforeunload', warn); };
    }, [editingTab, isCreate, hasUnsavedChanges, createdVendorId]);
    useEffect(function () {
        var previous = previousEditingTab.current;
        previousEditingTab.current = editingTab;
        if (editingTab && !previous) {
            window.requestAnimationFrame(function () { var _a, _b; return (_b = (_a = panelRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(FOCUSABLE)) === null || _b === void 0 ? void 0 : _b.focus({ preventScroll: true }); });
        }
        else if (!editingTab && previous) {
            window.requestAnimationFrame(function () { var _a; return (_a = document.getElementById(PORTAL_EDIT_BUTTON_ID)) === null || _a === void 0 ? void 0 : _a.focus(); });
        }
    }, [editingTab]);
    if (!isCreate && !(vendorId > 0)) {
        return React.createElement(Typography, { sx: { p: 3 } }, "Invalid portal.");
    }
    var showSkeleton = !config.isLoaded && !config.loadError;
    return (React.createElement(Box, { sx: { background: portalColors.pageBg, height: 'calc(100vh - 45px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' } },
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: "Warning, Unsaved Changes", message: "You are about to leave this section without saving. All changes will be lost. Do you really want to leave without saving?", acceptBtnText: "Save Changes", denyBtnText: "Leave without Saving", acceptCallBack: function () {
                setUnsavedOpen(false);
                handleSave();
            }, denyCallBack: function () {
                setUnsavedOpen(false);
                exitEdit();
                var next = pendingAction.current;
                pendingAction.current = null;
                next === null || next === void 0 ? void 0 : next();
            }, cancelCallBack: function () {
                setUnsavedOpen(false);
                pendingAction.current = null;
            }, open: unsavedOpen, key: "unsaved-".concat(unsavedOpen) }),
        isCreate && (React.createElement(React.Fragment, null,
            React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: "Are you sure?", message: "Are you sure you want to confirm creating the portal with the configuration selected?", acceptBtnText: "Confirm", denyBtnText: "Cancel", acceptCallBack: handleConfirmedCreate, denyCallBack: function () { return setConfirmCreateOpen(false); }, cancelCallBack: function () { return setConfirmCreateOpen(false); }, open: confirmCreateOpen, key: "create-".concat(confirmCreateOpen) }),
            React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: "Quit Creation?", message: "All the information entered will be lost. Are you sure you want to exit this section?", acceptBtnText: "Yes", denyBtnText: "No", acceptCallBack: function () {
                    setQuitCreateOpen(false);
                    navigate(-1);
                }, denyCallBack: function () { return setQuitCreateOpen(false); }, cancelCallBack: function () { return setQuitCreateOpen(false); }, open: quitCreateOpen, key: "quit-".concat(quitCreateOpen) }),
            canContinueToBranding ? (React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.SUCCESS_ALERT, titleText: "Portal Created", message: "Portal is created successfully. Do you want to continue and update the branding content?", acceptBtnText: "Continue", denyBtnText: "Go back", acceptCallBack: continueToBranding, denyCallBack: goToPortalList, open: createdVendorId !== null, key: "created-".concat(createdVendorId !== null) })) : (React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.SUCCESS_ALERT, titleText: "Success!", message: "Portal has been created successfully.", acceptBtnText: "Ok", acceptCallBack: goToPortalList, open: createdVendorId !== null, key: "created-".concat(createdVendorId !== null) })))),
        React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1, sx: { px: 3, pt: 2, pb: 1 } },
            React.createElement(IconButton, { size: "small", "aria-label": "Back to portals", onClick: function () { return (isCreate ? setQuitCreateOpen(true) : guardUnsaved(function () { return navigate(NavigationConfig.DealerManagement); })); } },
                React.createElement(BackArrowIcon, null)),
            React.createElement(Typography, { component: "h1", sx: { fontSize: 20, fontWeight: 700, flex: 1 } }, isCreate ? 'Create Portal' : 'Portal Setup')),
        config.isFetching && React.createElement(LinearProgress, null),
        React.createElement(Box, { sx: { px: 3, pt: 1, pb: 2, flex: 1, minHeight: 0, overflowY: 'auto' } }, config.loadError ? (React.createElement(Alert, { severity: "error", action: React.createElement(Button, { color: "inherit", size: "small", onClick: function () { return config.reload(); }, disabled: config.isFetching }, "Retry"), sx: { alignItems: 'center' } }, config.loadError)) : showSkeleton ? (React.createElement(LoadingSkeleton, null)) : (React.createElement(React.Fragment, null,
            isCreate ? (React.createElement(PortalCreateHeader, { portal: config.portal, errors: config.errors, setField: config.setField, validateOne: config.validateOne })) : (React.createElement(PortalSummaryStrip, { portal: config.portal })),
            isCreate && !canCreate ? (React.createElement(Alert, { severity: "warning" }, "Creating a portal needs access to the Configurations section. Ask an administrator to update your role.")) : !activeTab ? (React.createElement(Alert, { severity: "info" }, "You don't have permission to view any section of this portal.")) : (React.createElement(React.Fragment, null,
                React.createElement(PortalTabs, { active: activeTab, visibleTabs: isCreate ? PORTAL_TAB_ORDER : visibleTabs, disabledTabs: isCreate ? { branding: 'Available after the portal is created' } : undefined, onChange: function (tab) { return tab !== activeTab && guardUnsaved(function () { return setSelectedTab(tab); }); }, action: !isCreate && editingTab !== activeTab && canEditActiveTab && !config.isFetching ? (React.createElement(PortalEditButton, { label: EDIT_LABELS[activeTab], onEdit: function () { return setEditingTab(activeTab); } })) : undefined }),
                React.createElement(Box, { ref: panelRef, role: "tabpanel", id: portalPanelId(activeTab), "aria-labelledby": portalTabId(activeTab), tabIndex: -1, sx: { outline: 'none' } }, activeTab === 'configurations' ? (React.createElement(ConfigurationsTab, { config: config, editing: isCreate || editingTab === 'configurations' })) : (React.createElement(BrandingTab, { config: config, editing: isCreate || editingTab === 'branding' })))))))),
        config.isLoaded && activeTab && (isCreate ? canCreate : editingTab === activeTab) && (React.createElement(StickyActionBar, { saveLabel: isCreate ? 'Create Portal' : undefined, saveDisabled: !isCreate && !hasUnsavedChanges, saving: config.isSaving, onCancel: function () { return (isCreate ? setQuitCreateOpen(true) : guardUnsaved(function () { return undefined; })); }, onSave: function () {
                pendingAction.current = null;
                handleSave();
            } }))));
};
var PortalDetailPage = function (props) {
    var _a;
    var id = useParams().id;
    return React.createElement(PortalDetailPageContent, __assign({ key: "".concat((_a = props.mode) !== null && _a !== void 0 ? _a : 'edit', "-").concat(id !== null && id !== void 0 ? id : 'new') }, props));
};
export default PortalDetailPage;
